import {
  openCartModal,
  closeCartModal,
  getPendingCart,
  reloadPendingCart,
  postCartItem,
  deleteCartItem,
  getInvoicingCart,
} from "@actions/cart-actions";
import { useDispatch, useSelector } from "react-redux";

export function usePendingCart() {
  return useSelector((state) => state.cart.pendingCart);
}

export function useIsCartModalOpen() {
  return useSelector((state) => state.cart.isCartModalOpen);
}

export function useUsePurchaseCredit() {
  return useSelector((state) => state.cart.usePurchaseCredit);
}

export function useOpenCartModal() {
  const dispatch = useDispatch();

  return () => dispatch(openCartModal());
}

export function useCloseCartModal() {
  const dispatch = useDispatch();

  return () => dispatch(closeCartModal());
}

export function useGetPendingCart() {
  const dispatch = useDispatch();

  return async (redeemName, usePurchaseCredit) => dispatch(
    getPendingCart(redeemName, usePurchaseCredit),
  );
}

export function useReloadPendingCart() {
  const dispatch = useDispatch();

  return async () => dispatch(reloadPendingCart());
}

export function useGetInvoicingCart() {
  const dispatch = useDispatch();

  return async (cartId) => dispatch(
    getInvoicingCart(cartId),
  );
}

export function usePostCartItem() {
  const dispatch = useDispatch();

  return async (variantId) => dispatch(postCartItem(variantId));
}

export function useDeleteCartItem() {
  const dispatch = useDispatch();

  return async (cartItemId) => dispatch(deleteCartItem(cartItemId));
}
